export const fieldVisibilityConfig = {
    extraFilter: ['appz'],
    commissionAgentJson: ['appz'], //the list of roles can be merchant, psp, agent too
    commissionMerchantJson: ['appz'],
    commissionGwJson: ['appz'],
    systemAccount: ['appz'],
    terminalGateway: ['appz'],
    merchantTerminal: ['appz'],
    totalPaymentsBalance: ['appz', 'psp', 'agent'],
    totalPayoutsBalance: ['appz', 'psp', 'agent'],
    totalFees: ['appz', 'psp', 'agent'],
    totalDepositsBalance: ['appz', 'psp', 'agent'],
    totalWithdrawalsBalance: ['appz', 'psp', 'agent'],
    currentBalance: ['appz', 'psp', 'agent'],
    totalAgentCommission: ['appz'],
    totalIncludedCommission: ['appz', 'merchant'],
    totalOntopCommission: ['appz', 'merchant'],
    totalIncludedCommissionGwCost: ['appz', 'psp'],
    totalOntopCommissionGwCost: ['appz', 'psp'],
    cascadingStatus: ['appz', 'psp', 'agent'],
    originalPaymentId: ['appz'],
    internalStateDescription: ['appz'],
    ecomCascadeRule: ['appz'],
    p2pCascadeRule: ['appz'],
    payoutCascadeRule: ['appz'],
    redirectCascadeRule: ['appz'],
};
